import React, { FC } from 'react'

import { ButtonContainer, Page, PageContent } from 'common'
import { SignalFeedback } from 'components'
import { Button } from 'common/styles/layouts'

import { FeedbackPageViewContainer } from '../styles/FeedbackPage.styles'
import { TFeedbackPageContent } from '../types/FeedbackPage.types'

export const FeedbackPageView: FC<TFeedbackPageContent> = ({
  type,
  content: { title, details, confirmButton, icon, hasScroll = false, ref },
  onClick,
}) => (
  <Page>
    <FeedbackPageViewContainer ref={ref}>
      <PageContent>
        <SignalFeedback title={title} details={details} icon={icon} type={type} />
      </PageContent>
      <ButtonContainer $hasScroll={hasScroll}>
        <Button fullWidth onClick={onClick}>
          {confirmButton}
        </Button>
      </ButtonContainer>
    </FeedbackPageViewContainer>
  </Page>
)
